module.exports = __webpack_public_path__ + "static/media/icon_chevron_light_grey.020e0744.svg";